import React, { useState, useEffect, useRef } from "react";

//created components
import ContratAccess from '../contrataccess/ContratAccess.jsx'

//selectors for redux :
import { useSelector, useDispatch } from "react-redux";
import { getIdSpot, getLivraison, getRidingPeriod, getPanier, getShowPanier } from "../../../../../../store/selectors.js";
import { contratStepSlice } from "../../../../../../store/contratStepSlice.js";

//data
import taglist from "../../../../../../database/taglist.json";

//MUI Components
import Button from '@mui/material/Button';

function AccessGallery({ accessoires, startResa }) { // component to manage the first step of shopping : choosing place and time


    const dispatch = useDispatch();
    //let panier = useSelector(getPanier);


    function nextStep() {
        //Manager mode
        dispatch(contratStepSlice.actions.nextContratStep());
    }

    return (
        <div >
            <div className="shopping-gallery">

                <div className="shopping-gallery-middle gallery-access-flex-wrap">
                    {accessoires.map((access) => <ContratAccess key={access.id_article} access={access} />)}
                </div>

                {startResa === false ?
                    <div className="shopping-gallery-bottom">
                        <Button
                            className="shopping-gallery-bottom-bouton-panier"
                            variant="contained"
                            onClick={_ => nextStep()}
                        >Valider ces accessoires</Button>
                    </div>
                    : null}



            </div>

        </div>

    )
}




export default AccessGallery